export enum TimetableItemTypes {
  TMP,
  COURSE,
  BLOCKED,
  HOLIDAY,
  HANDOUTEVENT,
}
